import { render, staticRenderFns } from "./DocumentGroupType.vue?vue&type=template&id=796ec522&scoped=true&"
import script from "./DocumentGroupType.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupType.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupType.vue?vue&type=style&index=0&id=796ec522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ec522",
  null
  
)

export default component.exports